<template>
  <div v-if="content" class="content-card col card col-12 col-md-4" style="width: 18rem">
    <div :class="{ image: true, 'circle-img': circleImage }">
      <img :src="require(`@/assets/${imgSrc}`)" />
    </div>
    <div class="card-body text-center">
      <h5 class="card-title font-weight-bold" v-dynamic-content="{ rawText: content[title] }"></h5>
      <p class="card-text" v-dynamic-content="{ rawText: content[text] }"></p>
      <router-link
        to="/"
        class="next-link d-flex justify-content-center align-items-center font-weight-bold"
        v-if="link"
        v-dynamic-content="{ rawText: content[link] }"
      ></router-link>
    </div>
  </div>
  <div v-else>
    <loader></loader>
  </div>
</template>

<script>
export default {
  props: ['title', 'text', 'link', 'imgSrc', 'circleImage'],
}
</script>
